var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.show,
          expression: "show",
        },
      ],
      attrs: { id: "notificationNotice" },
      on: { click: _vm.clickBanner },
    },
    [
      _c("span", { staticClass: "icon" }),
      _vm._v(" "),
      _c("span", { staticClass: "text", class: { ios: _vm.ios } }, [
        _vm._v("开启推送通知，重要消息不错过"),
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "close", on: { click: _vm.closeNotice } }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }